import { render, staticRenderFns } from "./workerCard.vue?vue&type=template&id=0c1acf17&scoped=true&"
import script from "./workerCard.vue?vue&type=script&lang=js&"
export * from "./workerCard.vue?vue&type=script&lang=js&"
import style0 from "./workerCard.vue?vue&type=style&index=0&id=0c1acf17&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1acf17",
  null
  
)

export default component.exports